import React from 'react';
import { arrayOf, object } from 'prop-types';
import { connect } from 'react-redux';
import RecurringOptionsHeader from './RecurringOptionsHeader';
import RecurringOptionsCol from './RecurringOptionsCol';

const RecurringOptionsRow = ({ packageList }) => (
    <tr className="recurring-options-row">
        <RecurringOptionsHeader/>
        {packageList.map(({ id }) => (
            <RecurringOptionsCol key={id} packageId={id}/>
        ))}
    </tr>
);

RecurringOptionsRow.propTypes = {
    packageList: arrayOf(object)
};

const mapStateToProps = ({ packages }) => {
    const { packageList } = packages;

    return { packageList };
};

export { RecurringOptionsRow };
export default connect(mapStateToProps)(RecurringOptionsRow);
